import { useState } from "react";
import {
  Avatar,
  Box,
  HStack,
  Icon,
  Link,
  Text,
  VStack,
} from "@chakra-ui/react";
import type { APIListingAgentUser } from "models/types/api-listing";
import EmailIcon from "assets/icons/medium/email.svg?react";
import PhoneIcon from "assets/icons/medium/phone.svg?react";
import { useAgencyBranding } from "contexts/agency-settings-provider";
import { getLowestResolutionImageSource } from "utils/images";

type ContactItemProps = {
  agent: APIListingAgentUser;
};
export function ContactItem({ agent }: ContactItemProps) {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const { secondaryLogo } = useAgencyBranding();

  const phone =
    agent.phones.find((p) => p.type === "mobile")?.number ||
    agent.phones.find((p) => p.type === "direct")?.number;

  const profileImage = getLowestResolutionImageSource(agent.profile_image);

  const formattedEmail = agent?.email_address?.replace(/([.@])/g, "$1\u200B");

  return (
    <HStack
      w={"100%"}
      alignItems={"flex-start"}
      onClick={() => setIsContactOpen(!isContactOpen)}
      gap={4}
    >
      <Avatar
        src={profileImage?.url ?? secondaryLogo}
        name={agent.name}
        w={"56px"}
        h={"56px"}
      />
      <VStack justify={"center"} h={"100%"} gap={0} alignItems={"flex-start"}>
        <Text
          fontSize={"14px"}
          fontWeight={600}
          color={"client.navigation.text.primary"}
        >
          {agent.name}
        </Text>
        {agent.position && (
          <Text
            fontSize={"14px"}
            fontWeight={400}
            color={"client.navigation.text.secondary"}
          >
            {agent.position}
          </Text>
        )}
        <Box w={"100%"}>
          {phone && (
            <HStack>
              <Icon as={PhoneIcon} boxSize={"12px"} />
              <Link href={`tel:${phone}`}>
                <Text
                  fontSize={"14px"}
                  fontWeight={400}
                  color={"client.navigation.text.secondary"}
                >
                  {phone}
                </Text>
              </Link>
            </HStack>
          )}
          {formattedEmail && (
            <HStack>
              <Icon as={EmailIcon} boxSize={"12px"} />
              <Link href={`mailto:${agent.email_address}`}>
                <Text
                  fontSize={"14px"}
                  fontWeight={400}
                  color={"client.navigation.text.secondary"}
                  wordBreak={"break-word"}
                >
                  {formattedEmail}
                </Text>
              </Link>
            </HStack>
          )}
        </Box>
      </VStack>
    </HStack>
  );
}
